module.exports = __webpack_public_path__ + "static/media/cars-background.c4a7414f.png";